export const GET_INPOSTPAY_CONFIG = 'GET_INPOSTPAY_CONFIG';

export const getInpostPayConfig = (config) => ({
    type: GET_INPOSTPAY_CONFIG,
    config
});
